import React, { useMemo } from 'react';
import { ProsjektActions } from '../ProsjektActions/ProsjektActions';
import { useCurrentUser } from '@klp/auth';
import { StickyBox } from '@klp/design/StickyBox/StickyBox';
import { Paper } from '@material-ui/core';
import { Loader } from '@klp/design/Loader';
import { useProsjektSammendragContext } from './context/ProsjektSammendragProvider';

export const ProsjektSammendragProcessActions: React.FC = () => {
    const { currentUser } = useCurrentUser();

    const {
        initialProcess,
        initialProcessIsLoading,
        currentProcess,
        selectedProcess,
    } = useProsjektSammendragContext();

    const isHistoricalProcess = useMemo(() => {
        return currentProcess?.historiskeProsessSteg.some(
            (step) =>
                step.prosessInstansId === selectedProcess?.prosessInstansId,
        );
    }, [currentProcess, selectedProcess]);

    if (!initialProcess) return null;

    const allowedSteps = isHistoricalProcess
        ? []
        : initialProcess.tillattNesteSteg;

    return (
        <StickyBox>
            <Paper elevation={2}>
                <Loader isLoading={initialProcessIsLoading}>
                    <ProsjektActions
                        prosjekt={initialProcess}
                        isEDAdmin={currentUser?.isEDAdmin}
                        selectedElement="sammendrag"
                        allowedSteps={allowedSteps}
                        navigateOnDelete={true}
                    />
                </Loader>
            </Paper>
        </StickyBox>
    );
};
